/**
 * i18n minimalista: lookup dotted-key → string, con interpolación {name}.
 * Locale persistido en localStorage. Cambio en caliente via setLocale().
 *
 * No usamos lib (i18next/etc) porque el set de strings es chico y queremos
 * mantener el bundle delgado. Si crece mucho, migrar.
 */

import { es } from './es';
import { en } from './en';

export type Locale = 'es' | 'en';

const DICTIONARIES: Record<Locale, Record<string, string>> = { es, en };
const KEY = 'cgt_locale';

let currentLocale: Locale = (localStorage.getItem(KEY) as Locale) || detectBrowser();
const listeners = new Set<(locale: Locale) => void>();

function detectBrowser(): Locale {
  const lang = (navigator.language || 'es').toLowerCase();
  return lang.startsWith('en') ? 'en' : 'es';
}

/** Traduce una clave. Si falta en el locale actual, cae a es. Soporta {name}. */
export function t(key: string, params?: Record<string, string | number>): string {
  const dict = DICTIONARIES[currentLocale];
  const raw = dict[key] ?? DICTIONARIES.es[key] ?? key;
  if (!params) return raw;
  return raw.replace(/\{(\w+)\}/g, (_, k) => String(params[k] ?? `{${k}}`));
}

export function getLocale(): Locale {
  return currentLocale;
}

export function setLocale(locale: Locale): void {
  if (!(locale in DICTIONARIES)) return;
  currentLocale = locale;
  localStorage.setItem(KEY, locale);
  document.documentElement.lang = locale;
  listeners.forEach(fn => fn(locale));
}

export function onLocaleChange(fn: (locale: Locale) => void): () => void {
  listeners.add(fn);
  return () => { listeners.delete(fn); };
}

// Setear lang del <html> al cargar
document.documentElement.lang = currentLocale;
